import z from 'zod'
import {
  nullSafeOptionalBoolean,
  nullSafeOptionalString,
  nullSafeString,
  nullSafeStringArray,
} from '../shared/schema'
import { promptVersionPromptFields } from '../../types'

export const schema = z.object({
  title: nullSafeString(''),
  description: nullSafeString(''),
  requiredPrompts: z
    .array(z.enum([...promptVersionPromptFields, 'confidenceThreshold']))
    .default([]),
  optionalPrompts: z.array(z.enum(promptVersionPromptFields)).default([]),
  requiredFields: nullSafeStringArray([]),
  promptType: z.literal('post_room_state_prompt'),
  showTestingTab: nullSafeOptionalBoolean(false),
  promptSchemas: z
    .record(z.enum(promptVersionPromptFields), z.string())
    .default({}),
  trigger: nullSafeOptionalString(),
})

export const empty = Object.freeze(
  schema.parse({
    promptType: 'post_room_state_prompt',
    requiredPrompts: [],
    optionalPrompts: [],
  })
)

export type FirestorePromptPostRoomStateType = z.infer<typeof schema>
